module.exports = __webpack_public_path__ + "static/media/5DPO18.839cd08d.jpg";